import React from 'react';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSignupLocationsFilter } from './useSignupLocationsFilter';

export const SignupLocationsFilter = ({ value, setFilters, sharedList, orderBy }) => {
  const { formSchema, onSearchChange, onSubmit } = useSignupLocationsFilter({
    sharedList,
    orderBy,
    setFilters,
  });

  return (
    <Formik
      initialValues={{ signupLocations: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="signupLocations"
          label="Preferred locations"
          placeholder="Search to add"
          size="small"
          component={FormAsyncMultiSelect}
          loadOptions={onSearchChange}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

SignupLocationsFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
  sharedList: PropTypes.object,
  orderBy: PropTypes.oneOf(['count', 'alpha']),
};

SignupLocationsFilter.defaultProps = {
  value: [],
  sharedList: null,
  orderBy: 'count',
};
